(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RaceDialogController', RaceDialogController);

    RaceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Race', 'Trainer', 'Schedule'];

    function RaceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Race, Trainer, Schedule) {
        var vm = this;

        vm.race = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.trainers = Trainer.query();
        vm.schedules = Schedule.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.race.id !== null) {
                Race.update(vm.race, onSaveSuccess, onSaveError);
            } else {
                Race.save(vm.race, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:raceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.finishDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
